import { useState, useRef, useEffect } from 'react';
import configment from '@adc/configment';
import { getListingImageUrl } from '../../utils/listing';
import useMountEffect from '../useMountEffect';
export const useBackgroundImageWithFallback = (imageUrl, showEnhanced, alreadyVerifiedPhoto = null, onUnmount = () => { }, defaultPhotoConfigKey = 'LISTING_DEFAULT_PHOTO_URL') => {
    if (alreadyVerifiedPhoto) {
        return alreadyVerifiedPhoto;
    }
    const defaultPhotoUrl = configment.get(defaultPhotoConfigKey, '');
    const targetPhotoUrl = imageUrl !== defaultPhotoUrl
        ? getListingImageUrl(imageUrl, showEnhanced?.enabled, defaultPhotoUrl)
        : imageUrl;
    if (typeof window === 'undefined' || typeof Image === 'undefined') {
        return targetPhotoUrl;
    }
    const helperImg = useRef(null);
    const fallbackPhotoUrl = imageUrl;
    const [backgroundImageUrl, setBackgroundImageUrl] = useState(targetPhotoUrl || defaultPhotoUrl);
    const updateImage = imageUrl => {
        setBackgroundImageUrl(imageUrl);
        cleanRef();
    };
    const cleanRef = () => {
        if (helperImg.current) {
            helperImg.current.onload = null;
            helperImg.current.onerror = null;
            helperImg.current = null;
        }
    };
    useEffect(() => {
        if (imageUrl &&
            backgroundImageUrl &&
            imageUrl !== backgroundImageUrl &&
            backgroundImageUrl !== getListingImageUrl(imageUrl, true, defaultPhotoUrl)) {
            setBackgroundImageUrl(imageUrl);
        }
        else if (!imageUrl) {
            setBackgroundImageUrl(defaultPhotoUrl);
        }
    }, [imageUrl, backgroundImageUrl, defaultPhotoUrl]);
    const getValidBackgroundImageUrl = (imageUrl, fallbackPhotoUrl = null) => {
        const testFallbackImage = () => {
            if (fallbackPhotoUrl?.length) {
                return getValidBackgroundImageUrl(fallbackPhotoUrl);
            }
            updateImage(defaultPhotoUrl);
        };
        if (imageUrl?.length) {
            if (imageUrl === defaultPhotoUrl) {
                updateImage(defaultPhotoUrl);
                return;
            }
            const img = new Image();
            img.onload = () => updateImage(imageUrl);
            img.onerror = testFallbackImage;
            img.src = imageUrl;
            helperImg.current = img;
        }
        else {
            testFallbackImage();
        }
    };
    useMountEffect(() => {
        getValidBackgroundImageUrl(targetPhotoUrl, fallbackPhotoUrl);
        return () => {
            if (helperImg.current) {
                onUnmount();
                cleanRef();
            }
        };
    });
    return backgroundImageUrl;
};
export default useBackgroundImageWithFallback;
//# sourceMappingURL=index.js.map